import axios from "axios";
import CookieHelper from "./cookieHelper";
import API_CONFIG from "../config/apiConstant";
import { store } from "../store";
import { logout } from "../store/slices/authSlice";
import logger from "./logger";

async function callApi(
  method = "POST",
  url,
  body = null,
  headers = { "Content-Type": "application/json" },
  cancelToken,
  responseType = "json",
  timeout = API_CONFIG.TIMEOUT
) {
  const cookieHelper = new CookieHelper();
  const userData = cookieHelper.getUserCookie();

  // Build full URL if relative path (endpoints from API_CONFIG are already absolute)
  const fullUrl =
    /^https?:\/\//.test(url) || url.startsWith(API_CONFIG.BASE_URL)
      ? url
      : `${API_CONFIG.BASE_URL}${url}`;

  // Handle FormData (browser sets correct content-type)
  if (body instanceof FormData) {
    const { "Content-Type": removed, ...rest } = headers;
    headers = rest;
  }

  // Add authorization header if user data exists
  if (userData && userData.token) {
    headers.Authorization = `Bearer ${userData.token}`;
    logger.debug("Using token from cookies for authentication");
  } else {
    // Try to get token from localStorage as fallback
    const token = localStorage.getItem(API_CONFIG.STORAGE_KEYS.ACCESS_TOKEN);
    if (token) {
      headers.Authorization = `Bearer ${token}`;
      logger.debug("Using token from localStorage for authentication");
    } else {
      logger.warn("No authentication token found in cookies or localStorage");
    }
  }

  logger.api(method, fullUrl, body, "request");

  return new Promise((resolve, reject) => {
    const axiosConfig = {
      method,
      url: fullUrl,
      headers,
      responseType,
      timeout,
      data: body || undefined,
    };

    axios(axiosConfig)
      .then((res) => {
        logger.api(method, fullUrl, res.data, "response");
        logger.info("API call successful:", res.status);
        resolve(res);
      })
      .catch((err) => {
        logger.error("Network helper error:", err);

        // Handle 401 unauthorized errors
        if (err?.response?.status === 401) {
          logger.warn("Token expired - logging out user");
          store.dispatch(logout());
        }

        // Handle network errors
        if (err.code === 'ECONNABORTED') {
          logger.warn("Request timeout");
        }

        reject(err);
      });
  });
}

export default callApi;
